import * as ForwardViewletCommand from '../ForwardViewletCommand/ForwardViewletCommand.js'

export const handleInput = ForwardViewletCommand.forwardViewletCommand('handleInput')
export const handleClick = ForwardViewletCommand.forwardViewletCommand('handleClick')
export const handleScrollBarMove = ForwardViewletCommand.forwardViewletCommand('handleScrollBarMove')
export const handleScrollBarClick = ForwardViewletCommand.forwardViewletCommand('handleScrollBarClick')
export const toggleReplace = ForwardViewletCommand.forwardViewletCommand('toggleReplace')
export const toggleMatchCase = ForwardViewletCommand.forwardViewletCommand('toggleMatchCase')
export const toggleMatchWholeWord = ForwardViewletCommand.forwardViewletCommand('toggleMatchWholeWord')
export const replaceAll = ForwardViewletCommand.forwardViewletCommand('replaceAll')
export const toggleUseRegularExpression = ForwardViewletCommand.forwardViewletCommand('toggleUseRegularExpression')
export const handleReplaceInput = ForwardViewletCommand.forwardViewletCommand('handleReplaceInput')
export const handleListFocus = ForwardViewletCommand.forwardViewletCommand('handleListFocus')
export const handleListBlur = ForwardViewletCommand.forwardViewletCommand('handleListBlur')
